/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserDto } from './UserDto';
import {
    UserDtoFromJSON,
    UserDtoFromJSONTyped,
    UserDtoToJSON,
    UserDtoToJSONTyped,
} from './UserDto';
import type { SignatureProgressDto } from './SignatureProgressDto';
import {
    SignatureProgressDtoFromJSON,
    SignatureProgressDtoFromJSONTyped,
    SignatureProgressDtoToJSON,
    SignatureProgressDtoToJSONTyped,
} from './SignatureProgressDto';
import type { ApplicationFormStatus } from './ApplicationFormStatus';
import {
    ApplicationFormStatusFromJSON,
    ApplicationFormStatusFromJSONTyped,
    ApplicationFormStatusToJSON,
    ApplicationFormStatusToJSONTyped,
} from './ApplicationFormStatus';

/**
 * 
 * @export
 * @interface ApplicationFormVersionListItemDto
 */
export interface ApplicationFormVersionListItemDto {
    /**
     * 
     * @type {string}
     * @memberof ApplicationFormVersionListItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationFormVersionListItemDto
     */
    applicationFormId: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationFormVersionListItemDto
     */
    versionNumber: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationFormVersionListItemDto
     */
    name: string;
    /**
     * 
     * @type {ApplicationFormStatus}
     * @memberof ApplicationFormVersionListItemDto
     */
    status: ApplicationFormStatus;
    /**
     * 
     * @type {string}
     * @memberof ApplicationFormVersionListItemDto
     */
    organizationId: string;
    /**
     * 
     * @type {UserDto}
     * @memberof ApplicationFormVersionListItemDto
     */
    createdBy: UserDto;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationFormVersionListItemDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApplicationFormVersionListItemDto
     */
    signedAt?: Date;
    /**
     * 
     * @type {UserDto}
     * @memberof ApplicationFormVersionListItemDto
     */
    signedBy?: UserDto;
    /**
     * 
     * @type {SignatureProgressDto}
     * @memberof ApplicationFormVersionListItemDto
     */
    signatureProgress?: SignatureProgressDto;
    /**
     * Identifier of the clause library version used to generate the works agreement
     * @type {string}
     * @memberof ApplicationFormVersionListItemDto
     */
    clauseLibraryVersion?: string | null;
    /**
     * Set when this version is frozen on an older clause library version than the newest available one. Derived, never stored: the frozen version stays as it is.
     * @type {string}
     * @memberof ApplicationFormVersionListItemDto
     */
    newerClauseLibraryVersion?: string | null;
}



/**
 * Check if a given object implements the ApplicationFormVersionListItemDto interface.
 */
export function instanceOfApplicationFormVersionListItemDto(value: object): value is ApplicationFormVersionListItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('applicationFormId' in value) || value['applicationFormId'] === undefined) return false;
    if (!('versionNumber' in value) || value['versionNumber'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ApplicationFormVersionListItemDtoFromJSON(json: any): ApplicationFormVersionListItemDto {
    return ApplicationFormVersionListItemDtoFromJSONTyped(json, false);
}

export function ApplicationFormVersionListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationFormVersionListItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'applicationFormId': json['applicationFormId'],
        'versionNumber': json['versionNumber'],
        'name': json['name'],
        'status': ApplicationFormStatusFromJSON(json['status']),
        'organizationId': json['organizationId'],
        'createdBy': UserDtoFromJSON(json['createdBy']),
        'createdAt': (new Date(json['createdAt'])),
        'signedAt': json['signedAt'] == null ? undefined : (new Date(json['signedAt'])),
        'signedBy': json['signedBy'] == null ? undefined : UserDtoFromJSON(json['signedBy']),
        'signatureProgress': json['signatureProgress'] == null ? undefined : SignatureProgressDtoFromJSON(json['signatureProgress']),
        'clauseLibraryVersion': json['clauseLibraryVersion'] == null ? undefined : json['clauseLibraryVersion'],
        'newerClauseLibraryVersion': json['newerClauseLibraryVersion'] == null ? undefined : json['newerClauseLibraryVersion'],
    };
}

export function ApplicationFormVersionListItemDtoToJSON(json: any): ApplicationFormVersionListItemDto {
    return ApplicationFormVersionListItemDtoToJSONTyped(json, false);
}

export function ApplicationFormVersionListItemDtoToJSONTyped(value?: ApplicationFormVersionListItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'applicationFormId': value['applicationFormId'],
        'versionNumber': value['versionNumber'],
        'name': value['name'],
        'status': ApplicationFormStatusToJSON(value['status']),
        'organizationId': value['organizationId'],
        'createdBy': UserDtoToJSON(value['createdBy']),
        'createdAt': ((value['createdAt']).toISOString()),
        'signedAt': value['signedAt'] == null ? undefined : ((value['signedAt']).toISOString()),
        'signedBy': UserDtoToJSON(value['signedBy']),
        'signatureProgress': SignatureProgressDtoToJSON(value['signatureProgress']),
        'clauseLibraryVersion': value['clauseLibraryVersion'],
        'newerClauseLibraryVersion': value['newerClauseLibraryVersion'],
    };
}

